module.exports = __webpack_public_path__ + "img/multiplayer_intro.faedac5c.jpg";